import script from "./Blog.vue?vue&type=script&setup=true&lang=js"
export * from "./Blog.vue?vue&type=script&setup=true&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=57898ed9&scoped=true&lang=css"

import exportComponent from "/Users/tristan/WebstormProjects/tristanmartin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57898ed9"]])

export default __exports__